import { render } from "./TalentsList.vue?vue&type=template&id=78a06e0d&ts=true"
import script from "./TalentsList.vue?vue&type=script&lang=ts"
export * from "./TalentsList.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__